import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import BihamtaTable from "../../Components/BihamtaTable";
import { balanceReport } from "../store/api/DocumentsAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBalanceScale } from "@fortawesome/free-solid-svg-icons";
import ModalSelectCostCenter from "../Components/ModalSelectCostCenter";
import { exportToExcel, isMobileApp, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import { BookmarkFill, FileEarmarkExcelFill, List, PrinterFill, Search } from "react-bootstrap-icons";
import ModalAccountCheck from "../Components/ModalAccountCheck";

const AccountingBalance = () => {
    const total = useRef({});
    const history = useHistory();
    const dispatch = useDispatch();
    const { handleSubmit } = useForm();
    const { parentID, level } = useParams();
    const [pending, setPending] = useState(false);
    const levelNames = ["گروه", "کل", "معین", "تفصیلی"];
    const [popAccCheck, setPopAccCheck] = useState({ show: false });
    const [selectedCostCenter, selectCostCenter] = useState(null);
    const filterData = useRef({ ParentID: parentID, Level: level, PDateFrom: "", PDateTo: "" });
    const [popCostCenter, setPopCostCenter] = useState({ show: false });
    const list = useSelector(state => state.DocumentReducer.balanceReport);

    if (list?.Data && Array.isArray(list.Data)) {
        total.current.Debit = list.Data.map(l => l.Debit).reduce((a, b) => a + b, 0);
        total.current.Credit = list.Data.map(l => l.Credit).reduce((a, b) => a + b, 0);
        total.current.RemainedDebit = list.Data.map(l => l.RemainedDebit).reduce((a, b) => a + b, 0);
        total.current.RemainedCredit = list.Data.map(l => l.RemainedCredit).reduce((a, b) => a + b, 0);
    }
    else {
        total.current.Debit = total.current.Credit = total.current.RemainedCredit = total.current.RemainedDebit = 0;
    }
    function search() {
        filterData.current.Level = level;
        if (Number(parentID) > 0) {
            filterData.current.ParentID = parentID;
        }
        const pDateFrom = document.getElementsByName("DateFrom")[0].value;
        filterData.current.PDateFrom = pDateFrom;
        if (pDateFrom === "") {
            filterData.current.DateFrom = null;
        }
        const pDateTo = document.getElementsByName("DateTo")[0].value;
        filterData.current.PDateTo = pDateTo;
        filterData.current.CostCenterName = selectedCostCenter?.CenterName ?? "";
        if (pDateTo === "") {
            filterData.current.DateTo = null;
        }
        dispatch(balanceReport(filterData.current));

    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "کد حساب", colName: "AccountCodeLO", showInMobile: false, showCondition: () => Number(level) === 0 },
        { colTitle: "نام حساب", colName: "AccountNameLO", showInMobile: true, showCondition: () => Number(level) === 0 },
        { colTitle: "کد حساب", colName: "AccountCodeLOne", showInMobile: false, showCondition: () => Number(level) === 1 },
        { colTitle: "نام حساب", colName: "AccountNameLOne", showInMobile: true, showCondition: () => Number(level) === 1 },
        { colTitle: "کد حساب", colName: "AccountCodeLTwo", showInMobile: false, showCondition: () => Number(level) === 2 },
        { colTitle: "نام حساب", colName: "AccountNameLTwo", showInMobile: true, showCondition: () => Number(level) === 2 },
        { colTitle: "کد حساب", colName: "AccountCodeLThree", showInMobile: false, showCondition: () => Number(level) === 3 },
        { colTitle: "نام حساب", colName: "AccountNameLThree", showInMobile: true, showCondition: () => Number(level) === 3 },
        { colTitle: "بدهکار", colName: "Debit", showInMobile: true, colType: "currency" },
        { colTitle: "بستانکار", colName: "Credit", showInMobile: true, colType: "currency" },
        { colTitle: "مانده بدهکار", colName: "RemainedDebit", showInMobile: false, colType: "currency" },
        { colTitle: "مانده بستانکار", colName: "RemainedCredit", showInMobile: false, colType: "currency" },
        { colTitle: " ", colName: "AccCheckColor", colType: "color", showInMobile: false },
        { colTitle: "شرح بررسی", colName: "AccCheckDescription", colType: "color", showInMobile: false, showCondition: () => 0 === 1 }
    ];
    const tableRowButtons = [
        {
            title: "تراز " + levelNames[Number(level) + 1], type: "common", className: "group-Btn-smalll btn-secondary", onclick: rowClick, showCondition: () => isMobileApp() && Number(level) < 3
        },
        {
            title: "توضیحات", tooltip: "توضیحات ردیف", type: "common", className: "group-Btn-smalll btn-primary", onclick: showModalAccountCheck, icon: <BookmarkFill color="#811849" size={18} className="rowBtn" />
        }
    ]
    function showModalAccountCheck(row) {
        const id = Number(level) === 0 ? row.AccountIDLO : Number(level) === 1 ? row.AccountIDLOne : Number(level) === 2 ? row.AccountIDLTwo : row.AccountID;
        const accCat = row.AccountCat;
        setPopAccCheck({ show: true, checkType: "AccBalanceLevel" + level, relationID: id, accountCat: accCat, onSave: search });
    }
    function rowClick(row) {
        if (Number(level) < 3) {
            const l = Number(level) + 1;
            const pID = l === 1 ? row.AccountIDLO : l === 2 ? row.AccountIDLOne : row.AccountIDLTwo;
            history.push(`/Accounting/AccountingBalance/${l}/${pID}`);
        }
        else {
            history.push(`/Accounting/AccountingBook/3/${row.AccountID}/${row.AccountCat}`);
        }

    }
    function toExcel() {
        const url = "api/DocumentsAPI/AccountingBalance";
        const searchArgs = { ...filterData.current };
        if (!searchArgs.Level) {
            searchArgs.Level = level;
        }
        if (!searchArgs.ParentID && Number(parentID) > 0) {
            searchArgs.ParentID = parentID;
        }
        setPending(true);
        exportToExcel("AccountingBalanceL" + level, searchArgs, url, "post", tableColes, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData.current };
        if (!searchArgs.Level) {
            searchArgs.Level = level;
        }
        if (!searchArgs.ParentID && Number(parentID) > 0) {
            searchArgs.ParentID = parentID;
        }
        history.push({
            pathname: `/PrintViewer/AccountingBalanceL${level}/${e.ctrlKey}`,
            state: {
                dataUrl: `api/DocumentsAPI/AccountingBalance`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function showModalCostCenter(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            filterData.current.CostCenterID = data?.ID;
            selectCostCenter(data);
        }
        setPopCostCenter({
            show: true,
            onSelect: onSelect
        });

    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-امور مالی";
        const data = { Level: level };
        if (Number(parentID) > 0) {
            data.ParentID = parentID;
        }
        dispatch(balanceReport(data));
    }, [level, parentID]);
    return (
        <div className="container-fluid mt-2">
            <br />
            <ModalSelectCostCenter popData={popCostCenter} setPopCostCenter={setPopCostCenter} />
            <ModalAccountCheck popData={popAccCheck} setPopData={setPopAccCheck} />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faBalanceScale} size="lg" />
                    &nbsp;
                    تراز آزمایشی سطح {levelNames[level]}
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)}>
                        <Row className="rowBorder">
                            <Col md={2} className="form-group">
                                <label>از تاریخ: </label>
                                <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DateFrom" onChange={value => filterData.current.DateFrom = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تا تاریخ: </label>
                                <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DateTo" onChange={value => filterData.current.DateTo = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مرکز هزینه</label>
                                <input type="text" className="form-control" onKeyDown={showModalCostCenter} readOnly value={selectedCostCenter?.CenterName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: "26.5px" }}><List size={20} onClick={showModalCostCenter} /></Button>
                            </Col>
                            <Col md={3} className="form-group" style={{ display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "column" }}>
                                <Button type="submit" className="group-Btn-large mt-3" style={{ display: "block" }}><Search size={15} />&nbsp;نمایش تراز آزمایشی</Button>
                            </Col>
                        </Row>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px", marginBottom:"3px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData.current} rowClick={rowClick} className="mt-0"
                        searchMethod={(data) => dispatch(balanceReport(data))} reducerName="DocumentReducer" objectName="balanceReport" fixedHeight/>
                    <table>
                        <thead>
                            <tr>
                                <th>بدهکار</th>
                                <th>بستانکار</th>
                                <th>مانده بدهکار</th>
                                <th>مانده بستانکار</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <input className="tableRowInput" style={{ color: "red" }} value={total.current.Debit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                                <td>
                                    <input className="tableRowInput" style={{ color: "blue" }} value={total.current.Credit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                                <td>
                                    <input className="tableRowInput" style={{ color: "red" }} value={total.current.RemainedDebit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                                <td>
                                    <input className="tableRowInput" style={{ color: "blue" }} value={total.current.RemainedCredit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Card.Body>
            </Card>
        </div>
    )

}
export default AccountingBalance;